import { Modal, styled } from '@ori-ui/mui';

import { basePositionStyles } from '../../constants';
import { minibagWidthStyle } from '../MiniBag/styles';

const topNavHeightStyle = 'var(--top-nav-height, 0)';
const toolbarPositionStyle = 'var(--ecatalogue-toolbar-position, 0)';

export const Root = styled(Modal)<{
  ownerState: { breakpointIndex: number; useOpenedMinibagOnDesktop: boolean; isVisible: boolean };
}>(({ ownerState: { breakpointIndex, useOpenedMinibagOnDesktop, isVisible }, theme }) => {
  const isDesktop = breakpointIndex === 2;
  let animation = '--top-nav-height-animation';
  let left: number | string = 'auto';
  let top: number | string = topNavHeightStyle;
  if (isVisible) {
    if (useOpenedMinibagOnDesktop && isDesktop) {
      left = `calc(100vw - ${minibagWidthStyle})`;
    } else {
      left = 0;
    }
  }
  if (useOpenedMinibagOnDesktop) {
    animation = '--ecatalogue-toolbar-position-animation';
    top = isDesktop ? toolbarPositionStyle : 0;
  }

  return {
    ...basePositionStyles,
    display: 'block',
    left,
    position: 'fixed',
    textAlign: 'left',
    top,
    transition: `top var(${animation}, 0.3s ease-in-out)`,
    // top nav is has appBar index and minibag (overlay) should go under it
    zIndex: theme.zIndex.appBar - 1,
  };
});
